import React from "react";
import PropTypes from "prop-types";
import Tab from "./Tab.js";
import { TabsContainer, TabBar, TabPanel } from "./TabSectionStyles.js";

const TabSection = ({
  tabHeaders,
  showTabs,
  handleTabClick,
  activeSite,
  children,
}) => {
  const createTabs = () => {
    return tabHeaders.map((tabHeaderItem) => {
      const {siteName, site} = tabHeaderItem;

      return (
        <Tab
          key={siteName}
          id={siteName}
          label={site}
          isActive={activeSite === siteName}
          handleTabClick={handleTabClick}
        />
      );
    });
  };

  return (
    <TabsContainer>
      {showTabs && <TabBar>{createTabs()}</TabBar>}
      <TabPanel>{children}</TabPanel>
    </TabsContainer>
  );
};

TabSection.propTypes = {
  tabHeaders: PropTypes.array,
  showTabs: PropTypes.bool,
  handleTabClick: PropTypes.func,
  activeSite: PropTypes.string,
  children: PropTypes.any,
};
TabSection.defaultProps = {
  tabHeaders: [],
  showTabs: false,
  activeSite: 'HomeDepot',
};

export default TabSection;
